export default "__VITE_ASSET__B$VcAeEi__"